import { curtainShrinkAnimation, curtainGrowAnimation } from "./styles.css";

export const curtainIsOpening = () => {
  const curtain = document.querySelector<HTMLElement>("#__transition-curtain");
  const openingAnimation = curtain
    ?.getAnimations()
    ?.find(
      (animation) =>
        "animationName" in animation &&
        animation.animationName === curtainShrinkAnimation,
    ) as CSSAnimation | undefined;

  return openingAnimation?.finished ?? Promise.resolve();
};

export const curtainIsClosed = () => {
  const curtain = document.getElementById("__transition-curtain");

  return new Promise<void>((resolve) => {
    const onEnd = (e: AnimationEvent) => {
      if (e.animationName === curtainGrowAnimation) {
        resolve();
      }
    };

    curtain?.addEventListener("animationend", onEnd, { once: true });
  });
};
